import React from 'react';
import { PillsMenu, PillsMenuItem } from 'seduo-ui';
const Example = () => (<PillsMenu>
        <PillsMenuItem text="Přiřazené kurzy" selected={true}/>
        <PillsMenuItem text="To už dokončíte" dotColor="primary"/>
        <PillsMenuItem text="Uložené kurzy"/>
        <PillsMenuItem text="Doporučené pro vás"/>
        <PillsMenuItem text="Novinky v kurzech" dotColor="brand-orange"/>
        <PillsMenuItem text="Doporučené pro vás"/>
    </PillsMenu>);
export default Example;
